import { Component, Input, OnInit } from '@angular/core';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'app-custom-price',
  templateUrl: './custom-price.component.html',
  styleUrls: ['./custom-price.component.scss']
})
export class CustomPriceComponent implements OnInit {

  @Input() price: number;

  get knownPrice(): boolean {
    return isNotNullOrUndefined(this.price);
  }

  constructor() { }

  ngOnInit() {
  }

}
